import React, { useEffect, useState, useLayoutEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { I_CardsInfo_Common } from '@Redux/search/interfaces';
import { setAllSelected } from '@Redux/search/All/action';
import { setGroupSelected } from '@Redux/search/Group/action';
import { setHotelSelected } from '@Redux/search/Hotel/action';
import { setVocationSelected } from '@Redux/search/Vacation/action';
import { setTicketSelected } from '@Redux/search/Ticket/action';
import { setFlightSelected } from '@Redux/search/Flight/action';
import { setSendEmitApi } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import ResultNoData from '@components/SearchPage/ResultNoData';
import Spinner from '@components/Common/Spinner';
import Skeletons from '@components/Common/Skeletons';
import Card from './Card';
import styles from '../styles.module.scss';

export interface I_Props {
    isLogin: boolean;
}

const M = ({ isLogin }: I_Props) => {
    const { AllCardsInfo, FilterDataLoading, TagList, sendEmitApi } = useSelector(
        (state: RootState) => state.search.reducer
    );
    const { GroupFilterSelected } = useSelector((state: RootState) => state.search.GroupReducer);
    const { HotelFilterSelected } = useSelector((state: RootState) => state.search.HotelReducer);
    const { TicketFilterSelected } = useSelector((state: RootState) => state.search.TicketReducer);
    const { VocationFilterSelected } = useSelector(
        (state: RootState) => state.search.VocationReducer
    );
    const { FlightFilterSelected } = useSelector(
        (state: RootState) => state.search.FlightReducer
    );
    const { AllFilterSelected } = useSelector((state: RootState) => state.search.AllReducer);
    const dispatch = useDispatch();
    const [firstLoading, setFirstLoading] = useState(true);

    let selectedStore = AllFilterSelected;
    let dispatchFn = setAllSelected;
    switch (TagList) {
        case 'grp':
            dispatchFn = setGroupSelected;
            selectedStore = GroupFilterSelected;
            break;
        case 'htl':
            dispatchFn = setHotelSelected;
            selectedStore = HotelFilterSelected;

            break;
        case 'vac':
            dispatchFn = setVocationSelected;
            selectedStore = VocationFilterSelected;
            break;
        case 'etk':
            dispatchFn = setTicketSelected;
            selectedStore = TicketFilterSelected;
            break;
        case 'flt':
            dispatchFn = setFlightSelected;
            selectedStore = FlightFilterSelected;
            break;
        default:
            break;
    }

    // 載入更多 頁數改變時重新打API，觸發filterWithSort的useEffect
    function loadingMorePage() {
        const reqBody = {
            Page: 1,
            PageSize: 10 + selectedStore.PageSize,
        };
        dispatch(dispatchFn(reqBody));
        dispatch(setSendEmitApi(true));
    }
    // 此處邏輯 第一次渲染、更換篩選條件需是skeleton，點擊載入更多時則是spin
    // 頁數或條件、排序更動後觸發filterWithSort的useEffect，拿到新資料存入AllCardsInfo
    useEffect(() => {
        setFirstLoading(false);
    }, [AllCardsInfo]);
    useEffect(() => {
        // 因page放在selected裡如果pageSize為10代表別的篩選條件有更動
        if (selectedStore.PageSize === 10 && sendEmitApi) setFirstLoading(true);
    }, [TagList, selectedStore]);

    if (firstLoading)
        return (
            <>
                {Array.from(Array(10).keys()).map((index: number) => (
                    <Skeletons isMobile={true} key={'skeleton' + index} />
                ))}
            </>
        );

    return (
        <>
            <ul>
                {AllCardsInfo.DataList?.map((item: I_CardsInfo_Common, i: number) => (
                    <Card key={i} groupData={item} isLogin={isLogin} />
                ))}
            </ul>
            {/* if Loading 完成且確實沒有資料，顯示"查無資料" */}
            {AllCardsInfo.Total == 0 && <ResultNoData />}
            {FilterDataLoading && <Spinner />}

            {/* if 正在 Loading 或 沒有更多資料了，則不顯示"更多精彩行程"按鈕 */}
            {FilterDataLoading || selectedStore.PageSize >= AllCardsInfo.Total ? null : (
                <div className={styles.moreInfoWrapper}>
                    <div className={styles.moreInfo} onClick={loadingMorePage}>
                        更多精彩行程
                    </div>
                </div>
            )}
        </>
    );
};

export default M;
